import { Intent, Position, Toaster } from "@blueprintjs/core";
import {
    segmentTrackVoltageDropdownChange,
    VoltageFilterChangeSource
} from "analytics/analyticTrackEvents";
import useMapViewConfiguration from "contexts/MapViewConfigurationContext/hooks/useMapViewConfiguration";
import { KV_69, Voltage } from "types/voltageTypes";

const BranchesNotShownToaster = Toaster.create({
    position: Position.TOP
});

const useApplyVoltages = (
    source: VoltageFilterChangeSource
): ((voltages: ReadonlyArray<Voltage>) => void) => {
    const {
        busFiltersConfiguration: { busFilters, setVoltages }
    } = useMapViewConfiguration();

    return (voltages: ReadonlyArray<Voltage>) => {
        const newlyAdded = voltages.filter(
            (v) => !busFilters.voltages.includes(v)
        );
        if (newlyAdded.includes(KV_69)) {
            BranchesNotShownToaster.show({
                message: `${KV_69} kV transmission line data not available`,
                intent: Intent.WARNING
            });
        }
        setVoltages(voltages);
        if (newlyAdded.length > 0) {
            segmentTrackVoltageDropdownChange(
                [...voltages],
                busFilters,
                source
            );
        }
    };
};

export default useApplyVoltages;
